module.exports = __webpack_public_path__ + "static/img/5.8f9dfa9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shlzy/5.png
// module id = F1Ws
// module chunks = 0